export default "__VITE_ASSET__CAKjo78L__"